import axios from 'axios';

const apiUsers = {
    me: {
        get(idToken) {
            return axios
                .get(`${process.env.VUE_APP_APIURL}/users/me`, {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-From': location.href
                    }
                })
                .catch(error => {
                    throw error;
                });
        },
        put(params, idToken, oldIdToken) {
            return axios
                .put(`${process.env.VUE_APP_APIURL}/users/me`, params, {
                    headers: {
                        Authorization: 'Bearer ' + idToken,
                        'X-Authorization': oldIdToken,
                        'X-From': location.href
                    }
                })
                .catch(error => {
                    throw error;
                });
        },
        creditCard: {
            get(idToken) {
                return axios
                    .get(`${process.env.VUE_APP_APIURL}/users/me/credit-card`, {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        }
                    })
                    .catch(error => {
                        throw error;
                    });
            },
            put(params, idToken) {
                return axios
                    .put(
                        `${process.env.VUE_APP_APIURL}/users/me/credit-card`,
                        params,
                        {
                            headers: {
                                Authorization: 'Bearer ' + idToken,
                                'X-From': location.href
                            }
                        }
                    )
                    .catch(error => {
                        throw error;
                    });
            }
        },
        invoices: {
            get(idToken) {
                return axios
                    .get(`${process.env.VUE_APP_APIURL}/users/me/invoices`, {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        }
                    })
                    .catch(error => {
                        throw error;
                    });
            }
        }
    },
    name: {
        put(params, idToken, userId) {
            return axios
                .put(
                    `${process.env.VUE_APP_APIURL}/users/${userId}/name`,
                    params,
                    {
                        headers: {
                            Authorization: 'Bearer ' + idToken,
                            'X-From': location.href
                        }
                    }
                )
                .catch(error => {
                    throw error;
                });
        }
    }
};
export default apiUsers;
